const popoverPanel = () => {
	document.addEventListener('click', event => {
		// If the close button inside the popover is clicked
		const buttonClose = event.target.closest('.button-close');
		if (!buttonClose) return;

		const closestPopover = buttonClose.closest('[popover]');
		closestPopover?.hidePopover();
	});
};

export default popoverPanel;
